"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = {
    KSYS_APP_LOADED: 'ksys-app-loaded',
    KSYS_APPS_LOADED: 'ksys-apps-loaded',
    KSYS_APP_EMBED_ADDED: 'ksys-app-embed-added',
};
//# sourceMappingURL=Events.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/appsManager/Events.js
// module id = 804
// module chunks = 1